import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'generalinput',
  templateUrl: './generalinput.component.html',
  styleUrls: ['./generalinput.component.scss']
})
export class GeneralinputComponent {

  @Input() form!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() message?: string;
  @Input() alertMessage: string = 'Asegúrate de llenar este campo';
  @Input() placeholder!: string;
  @Input() isNumberOnly: boolean = false;
  @Input() isAlphaOnly: boolean = false;
  @Input() isReadOnly: boolean = false; // Add this line
  @Input() isMoney: boolean = false;
  @Input() isReFill: boolean = false;
  @Input() isEditable: boolean = false;
  @Input() isEmail: boolean = false; // Add this

  /* Si se habilita el icono
  debe activar la opcion OUPUT 'iconClick'
  para ejecutar la accion del icono boton
  */
  @Input() iconClass?: string;
  // Accion boton icono personalizado
  @Output() iconClick = new EventEmitter<void>();

  focusedControls: { [key: string]: boolean } = {}; // Map to track focus state
  constructor() { }

  ngOnInit(): void {
    if (!this.form) {
      console.error('Form is required for generaldate component');
    }
    if (!this.controlName) {
      console.error('ControlName is required for generaldate component');
    }
  }

  public isValidField(field: string) {
    const control = this.form.get(field);
    return control && control.errors && (control.dirty || control.touched);
  }

  public getErrorMessage(field: string): string {
    const control = this.form.get(field);

    if (!control?.errors) {
      return this.alertMessage;
    }

    if (control.errors['required']) {
      return this.alertMessage;
    }

    if (control.errors['emailInvalido']) {
      return control.errors['emailInvalido'];
    }

    if (control.errors['nombreInvalido']) {
      return control.errors['nombreInvalido'];
    }

    if (control.errors['lastNameInvalido']) {
      return control.errors['lastNameInvalido'];
    }

    if (control.errors['email']) {
      return 'Ingresa un correo electrónico válido';
    }

    if (control.errors['celular']) {
      return control.errors['celular'];
    }

    if (control.errors['numeric']) {
      return 'Este campo debe contener solo números';
    }

    if (control.errors['direccion']) {
      return control.errors['direccion'];
    }

    if (control.errors['minlength']) {
      return `Debe tener al menos ${control.errors['minlength'].requiredLength} caracteres`;
    }

    if (control.errors['maxlength']) {
      return `No puede superar ${control.errors['maxlength'].requiredLength} caracteres`;
    }

    if (control.errors['pattern']) {
      return 'Asegurate de ingresar un valor válido';
    }

    return this.alertMessage;
  }

  public validateNumber(event: KeyboardEvent): void {
    const pattern = /^[0-9]$/;
    const inputChar = event.key;

    // Permitir teclas de control (Backspace, Tab, Flechas, Delete)
    if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(inputChar)) {
      return;
    }

    // Bloquear caracteres especiales como tildes y diéresis
    if (!pattern.test(inputChar) || ['´', '¨', '`', '^', '~'].includes(inputChar)) {
      console.log('entro xx');
      event.preventDefault();
    }
  }

  public onInput(event: any, onlyNumber: boolean = true): void {
    // Eliminar cualquier carácter que no sea número o letra según el patrón
    const pattern = onlyNumber ? /[^0-9]/g : /[^A-Za-zÑñ\s]/g;

    event.target.value = event.target.value.replace(pattern, '');
  }

  public sanitizeEmailInput(event?: any): void {
    if (!this.isEmail) {
      return;
    }

    const control = this.form?.get(this.controlName);
    const rawValue = event?.target?.value ?? control?.value;
    const trimmedValue = rawValue.trim();

    control?.setValue(trimmedValue, { emitEvent: false });

  }

  validateAlpha(event: KeyboardEvent) {
    const regex = /^[A-Za-zÑñ\s]+$/;
    const inputChar = event.key;
    if (!regex.test(event.key) || ['´', '¨', '`', '^', '~'].includes(inputChar)) {
      console.log('entro ff');
      event.preventDefault();
    }
  }

  onFocus() {
    this.focusedControls[this.controlName] = true; // Set focus state to true
  }

  onBlur() {
    this.focusedControls[this.controlName] = false; // Set focus state to false

    if (this.isEmail) {
      this.sanitizeEmailInput();
      const control = this.form.get(this.controlName);
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });
    }
  }

  isFocused(controlName: string): boolean {
    return !!this.focusedControls[controlName]; // Return focus state
  }

  public generarEditar() {
    this.iconClick.emit();
  }

  blockUnicode(event: KeyboardEvent) {
    // Bloquea ñ y Ñ
    if (event.key === 'ñ' || event.key === 'Ñ') {
      event.preventDefault();
    }
  }
}
